module.exports = __webpack_public_path__ + "img/alert_error.567914b3.svg";